let productList = [
  {
    isReverse: false,
    title: [
      '硬件合作，商户服务，',
      '商务合作，微信邮箱：',
      'fzb@fyit.cc'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/contact/fy_contact_05.png'
  }
]

export default productList



// WEBPACK FOOTER //
// ./src/assets/conf/contact.js